import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import i18n from '../../i18n';
import Conversation from '../../models/Conversation';
import User from '../../models/User';
import createCalendar from '../../utils/OuiCal';

export default class ButtonAddToCalendar extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    constructor(props) {
        super(props);
        this.addToCalendarRef = React.createRef();
    }

    componentDidMount() {
        this.initAddToCalendarButton();
    }

    initAddToCalendarButton() {
        const exchange = this.props.conversation.getExchange();
        if (this.addToCalendarRef.current) {
            const btnCalendar = createCalendar({
                data: {
                    title: this.getTitle(exchange),
                    start: moment(exchange.get('start_on')).toDate(),
                    end: this.getEventEnd(exchange),
                    address: exchange.get('home').get('address')
                }
            });
            this.addToCalendarRef.current.appendChild(btnCalendar);
        }
    }

    /**
     * End of the check-out day, not its start.
     *
     * `end_on` is a check-out date ("2026-08-09"), which moment parses as
     * 00:00 local time. Passing that straight through made the exported event
     * finish at the very beginning of the departure day, so a Friday→Sunday
     * exchange showed up in Google Calendar as Friday→Saturday and the last
     * day silently disappeared (MOV-1727).
     */
    getEventEnd(exchange) {
        return moment(exchange.get('end_on')).endOf('day').toDate();
    }

    getTitle(exchange) {
        if (exchange.get('guest').id == this.props.user.id) {
            return i18n.t('exchange:my_exchange_in_at', {
                first_name: exchange.get('host').get('first_name'),
                location: exchange.get('home').location()
            });
        } else {
            return i18n.t('exchange:my_exchange_with_at', {
                first_name: exchange.get('guest').get('first_name'),
                location: exchange.get('home').location()
            });
        }
    }

    render() {
        return (
            <span className="btn btn-secondary btn-calendar" ref={this.addToCalendarRef}>
                {i18n.t('exchange:add_to_calendar')}
            </span>
        );
    }
}
